import useMediaQuery from "@mui/material/useMediaQuery";

export default function useMediaQueries() {
  const isMobileView = useMediaQuery("(max-width:900px)");
  const isTabletOrLess = useMediaQuery("(max-width: 1040px)");
  const is1400OrLess  = useMediaQuery("(max-width: 1400px)");

  return [isMobileView, isTabletOrLess, is1400OrLess];
}
